export default __webpack_public_path__ + "static/wakacje4-4ff128da4d26b2cd0c9d257f37bf79ab.png";